import numeral from 'numeral';

export const keys = [
    {
        key: 'author',
        label: 'Author',
    },
    {
        key: 'impressions',
        label: 'Impressions',
        className: 'list-data-secondary-text',
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        key: 'rank',
        label: 'Rank',
        bar: true,
        renderCell: ({ item, allData }) => {
            const max = getMax(allData);
            const percent = item.impressions / max;
            return percent * 100;
        },
    },
];

function getMax(data) {
    return data?.reduce((acc, curr) => {
        if (curr.impressions > acc) acc = curr.impressions;
        return acc;
    }, 0);
}
